export default __webpack_public_path__ + "static/13-8e2c81ae51c651e53280fe31e13d643c.png";